<template>
  <b-card class="shadow">
    <b-form @submit.stop.prevent="updatePassword">
      <b-card-title class="dark-variant">Change Password</b-card-title>
      <div class="general-container">
        <label for="Change-password" class="dark-variant">Enter your password</label>
        <div class="Enter-your-password">
          <b-form-input
            :type="visibility"
            :class="{'u-full-width' : !onlyunder, 'u-full-width onlyunder': onlyunder}"
            :maxlength="maxlength"
            placeholder="Enter your password"
            v-model="form.password"
          ></b-form-input>
          <a @click="showPassword()" class="notunderlined" v-if="visibility == 'password'">
            <b-icon icon="eye" icon-name="show password"></b-icon>
          </a>
          <a @click="hidePassword()" class="notunderlined" v-if="visibility == 'text'">
            <b-icon icon="eye-slash" icon-name="hide password"></b-icon>
          </a>
        </div>
        <span class="text-danger float-right" v-if="errors.password">{{ errors.password}}</span>
        <br clear="all" />

        <label for="confirm-password" class="dark-variant">Confirm your password</label>
        <div class="Enter-your-password">
          <b-form-input
            :type="visibility"
            :class="{'u-full-width' : !onlyunder, 'u-full-width onlyunder': onlyunder}"
            v-model="form.confirm_password"
            :maxlength="maxlength"
            placeholder="Confirm your password"
          ></b-form-input>
          <a @click="hidePassword()" class="notunderlined" v-if="visibility == 'password'">
            <b-icon icon="eye" icon-name="show password"></b-icon>
          </a>
          <a @click="hidePassword()" class="notunderlined" v-if="visibility == 'text'">
            <b-icon icon="eye-slash" icon-name="hide password"></b-icon>
          </a>
        </div>
        <span
          class="text-danger float-right"
          v-if="errors.confirm_password"
        >{{ errors.confirm_password}}</span>
        <br clear="all" />

        <div class>
          <b-button variant="primary" type="submmit" class="ml-1">Send</b-button>
        </div>
      </div>
    </b-form>
  </b-card>
</template>

<script>
export default {
  name: "TogglePassword",

  data() {
    return {
      visibility: "password",
      form: {
        password: "",
        confirm_password: "",
      },
      errors: [],
      passWordReg: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{6,20}$/,
    };
  },
  props: {
    placeholder: { type: String, default: "" },
    value: "",
    //maxlength: {type: Number, default: 50},
    onlyunder: { type: Boolean, default: false },
  },
  methods: {
    showPassword() {
      this.visibility = "text";
    },
    hidePassword() {
      this.visibility = "password";
    },
    updatePassword(e) {
      e.preventDefault();
      this.errors = [];

      if (this.form.password == "") {
        this.errors["password"] = "Password requried";
      } else if (!this.passWordReg.test(this.form.password)) {
        this.errors["password"] =
          "Password must contain uppercase, lowercase and  digit and special character.";
      } else if (this.form.confirm_password !== this.form.password) {
        this.errors["confirm_password"] = "Confirm password not matched";
      } else {
        //this.$bvModal.hide('security-question')
        console.log("Password Changed!");
      }
    },
  },
};
</script>

<style lang="scss">
  @import '../../css/style.scss';
</style>